'use client';

import { getAlgoliaSearchClient } from './client';
import { buildAlgoliaFilters } from './build-filters';
import { BARCODE_FACET_ATTR } from './barcode';
import type { AlgoliaProduct } from './types';

export interface BarcodeLookupResult {
  nbHits: number;
  hit?: AlgoliaProduct;
}

// EWM-927 — one-off exact barcode lookup used by the header search on submit.
// Filters (never full-text searches) on the normalized barcode facet, scoped to
// the dealer's product selection; buildAlgoliaFilters also excludes GO lines.
// hitsPerPage: 2 is enough to distinguish single vs multiple.
export const lookupBarcode = async ({
  securedApiKey,
  indexName,
  normalizedBarcode,
  productSelectionKeys,
}: {
  securedApiKey?: string;
  indexName: string;
  normalizedBarcode: string;
  productSelectionKeys?: string[];
}): Promise<BarcodeLookupResult> => {
  const client = getAlgoliaSearchClient(securedApiKey);
  const filters = buildAlgoliaFilters({
    productSelectionKeys,
    refinements: { [BARCODE_FACET_ATTR]: [normalizedBarcode] },
  });
  const res = await client.search<AlgoliaProduct>({
    requests: [{ indexName, query: '', hitsPerPage: 2, ...(filters ? { filters } : {}) }],
  });
  const main = ((res.results ?? []) as Array<{ hits?: AlgoliaProduct[]; nbHits?: number }>)[0];
  const hits = main?.hits ?? [];
  return { nbHits: main?.nbHits ?? 0, hit: hits[0] };
};
